import Button from '../shared/Button';
import useTripStore from '../../context/TripStore';

const PlaceCard = ({ place, isInList = false, index }) => {
  const { addPlace, removePlace, places } = useTripStore();

  // Double-check if place is in list (in case state updated)
  const actuallyInList = isInList || places.some(p => p.placeId === place.placeId);
  const listPlace = places.find(p => p.placeId === place.placeId);
  const displayPlace = actuallyInList && listPlace ? { ...place, id: listPlace.id, priority: listPlace.priority } : place;

  const handleAdd = (e) => {
    e.stopPropagation(); // Prevent card click from firing
    // Ensure place has all required fields
    const placeToAdd = {
      ...place,
      id: place.id || `place_${Date.now()}_${Math.random()}`,
    };
    addPlace(placeToAdd);
  };

  const handleRemove = (e) => {
    e.stopPropagation(); // Prevent card click from firing
    if (displayPlace.id) {
      removePlace(displayPlace.id);
    }
  };

  return (
    <div className="bg-white border border-gray-200 p-3 hover:border-gray-400 transition-colors cursor-pointer" 
         onClick={() => {
           // Center map on this place when clicked
           if (displayPlace.coordinates && window.backgroundMapInstance) {
             window.backgroundMapInstance.setCenter(displayPlace.coordinates);
             window.backgroundMapInstance.setZoom(15);
           }
         }}>
      <div className="flex gap-3">
        {actuallyInList && index && (
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-light">
            {index}
          </div>
        )}
        {displayPlace.photo && (
          <img
            src={displayPlace.photo}
            alt={displayPlace.name}
            className="w-20 h-20 object-cover flex-shrink-0"
          />
        )}
        <div className="flex-1 min-w-0">
          <h3 className="font-light text-sm mb-0.5 truncate">{displayPlace.name}</h3>
          {displayPlace.address && (
            <p className="text-xs font-light text-gray-500 mb-1 truncate">{displayPlace.address}</p>
          )}
          {displayPlace.rating > 0 && (
            <div className="flex items-center gap-1 mb-2">
              <span className="text-xs font-light text-gray-500">⭐</span>
              <span className="text-xs font-light text-gray-700">{displayPlace.rating.toFixed(1)}</span>
            </div>
          )}
          
          {actuallyInList ? (
            <div className="flex items-center gap-2 mt-2">
              <Button variant="secondary" onClick={handleRemove} className="text-xs py-0.5 px-2">
                Remove
              </Button>
            </div>
          ) : (
            <div className="mt-2">
              <Button onClick={handleAdd} className="text-xs py-0.5 px-2">
                Add to List
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaceCard;

